import { EntityKind } from 'mdello-client-ts/dist/src/interfaces/admin/entity.interface';
import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { getClient } from 'src/util/mdello-instance';
import { NotificationsResponseData } from './interfaces/notifications.interface';

const fetchNotifications = async (): Promise<NotificationsResponseData | undefined> => {
  const currentProject: any = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) return;

  const data = await getClient()?.listEntities({
    kind: EntityKind.NOTIFICATION,
    projectId: currentProject._id
  });

  if (!data) return;

  return { data: data.data, paging: data.paging };
};

export const useGetNotifications = () => {
  const { notify } = useNotification();

  return useQuery([QueryKey.NOTIFICATIONS], () => fetchNotifications(), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    }
  });
};
